// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Notify from "@monsma/XDL/Components/Notify/Notify";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderShipNotifyStyles {
    wrapper?: InjectableCss;
}

export const ShipNotifyStyles: OrderShipNotifyStyles = {};

const styles = ShipNotifyStyles;

const OrderShipNotify: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    const isShipCompleted = order.properties.shipComplete && order.properties.shipComplete.toLowerCase() === "true";

    return (
        <StyledWrapper {...styles.wrapper}>
            {isShipCompleted && (
                <Notify
                    messageType="warning"
                    body={siteMessage(
                        "Custom_ShipCompleteMessage",
                        "There is no partial shipment. Product will not ship till everything is in stock to ship. ",
                    )}
                    hideCloseButton
                    extendedStyles={{
                        cssOverrides: {
                            toast: css`
                                && {
                                    width: 100%;
                                    margin: 0;
                                    margin-top: 10px;
                                    margin-bottom: 10px;
                                }
                                @media print {
                                    display: block;
                                }
                            `,
                        },
                    }}
                />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderShipNotify,
    definition: {
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
